// TODO: 外部モジュールへの依存を消したい
import { useBrandAccountSurveysQueryData } from '~/hooks/useBrandAccountSurveysQuery'
import { useCommonQueryCurrentBrandAccount } from '~/hooks/useCommonQuery'

export const useCurrentBrandAccountSurveysQueryData = () => {
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()

  return useBrandAccountSurveysQueryData(currentBrandAccount?.id)
}
